/**
 * Removes the URL from an ID
 * @param {string} id full ID
 * @returns {string} ID without URL
 */
export const getShortId = (id) => id.substring(id.lastIndexOf("/") + 1);

/**
 * Simple way to compose functions. Accepts any number of functions.
 * The return value of fn1 is the input the fn2, etc.
 * @param  {...any} fns Functions to compose
 * @returns Result after all functions applied.
 */
export const pipe =
  (...fns) =>
  (x) =>
    fns.reduce((v, f) => f(v), x);

/**
 * Works like a .map() fn on an array, except the input object
 * is an object of key/val pairs.
 * Runs mapFn on each value of the key/val pairs.
 * @param {*} object Input object of key/val pairs
 * @param {*} mapFn Fn to run on each value object
 * @returns Remapped input object
 */
export const objectMap = (object, mapFn) =>
  Object.keys(object).reduce(function (result, key) {
    result[key] = mapFn(object[key]);
    return result;
  }, {});
